import { render, staticRenderFns } from "./CaseGroupModal.vue?vue&type=template&id=7befd248&"
import script from "./CaseGroupModal.vue?vue&type=script&lang=js&"
export * from "./CaseGroupModal.vue?vue&type=script&lang=js&"
import style0 from "./CaseGroupModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports